import React, {ReactElement} from 'react';
import {useTimeOverDetector, useMoneyOverDetector} from 'ui/utils/lifeCycle';
import {useMoneyLeft} from 'ui/utils/core';

import {Counter} from 'ui/components/Counter';
import {Success} from 'ui/components/Success';
import {Failure} from 'ui/components/Failure';
import {Container, SectionBorderConcealer} from './style';

export const Summary = (): ReactElement => {
  const timeOver = useTimeOverDetector();
  const moneyOver = useMoneyOverDetector();
  const isOver = timeOver || moneyOver;
  const moneyLeft = useMoneyLeft();

  let Component = Counter;
  if (isOver && moneyLeft > 0) Component = Success;
  if (isOver && moneyLeft <= 0) Component = Failure;

  return (
    <Container>
      <SectionBorderConcealer>
        <Component />
      </SectionBorderConcealer>
    </Container>
  );
};
